import { render } from "./doubleRow.vue?vue&type=template&id=5d7ed581&scoped=true"
import script from "./doubleRow.vue?vue&type=script&lang=js"
export * from "./doubleRow.vue?vue&type=script&lang=js"

import "./doubleRow.vue?vue&type=style&index=0&id=5d7ed581&scoped=true&lang=css"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7ed581"]])

export default __exports__